// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JXh2dQRPYHbchqNPPGUm h2,.JXh2dQRPYHbchqNPPGUm p{text-align:center}", "",{"version":3,"sources":["webpack://./src/code-studio/components/share-disallowed-dialog.module.scss"],"names":[],"mappings":"AACE,iDAEE,iBAAA","sourcesContent":[".dialog {\n  h2,\n  p {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": "JXh2dQRPYHbchqNPPGUm"
};
export default ___CSS_LOADER_EXPORT___;
